import { useNavigate } from 'react-router-dom'

import { ResourceHeader } from '@factorialco/f0-react/dist/experimental'

import { countryName } from 'modules/core/lib/countryList'
import i18n from 'modules/core/lib/i18n'

export type EmployeesImporterAction = 'create' | 'edit'

interface Props {
  title: string
  action: EmployeesImporterAction
  country: string
}

const actionLabel = (action: EmployeesImporterAction) => {
  return action === 'create'
    ? i18n.t('employees.importer.resource_header.metadata.action_create')
    : i18n.t('employees.importer.resource_header.metadata.action_edit')
}

export const EmployeesImporterPageResourceHeader = ({ title, country, action }: Props) => {
  const navigate = useNavigate()
  return (
    <ResourceHeader
      title={title}
      metadata={[
        {
          label: i18n.t('employees.importer.resource_header.metadata.country'),
          value: {
            type: 'text',
            content: countryName(country),
          },
        },
        {
          label: i18n.t('employees.importer.resource_header.metadata.action'),
          value: {
            type: 'text',
            content: actionLabel(action),
          },
        },
      ]}
      secondaryActions={[
        {
          label: i18n.t('employees.importer.resource_header.secondary_actions.cancel'),
          onClick: () => navigate(-1),
        },
      ]}
    />
  )
}
